import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { readyInterviewJobIds } from '@/lib/forkhire/interview/interviewReadiness';

/**
 * Returns a Set of job IDs that have a published interview config.
 * Used to determine if "interviewed" stage should be available per-job.
 */
export function useJobInterviewReady(jobIds: string[]) {
  return useQuery({
    queryKey: ['job-interview-ready', jobIds],
    queryFn: async () => {
      if (jobIds.length === 0) return new Set<string>();
      const { data } = await supabase
        .from('interview_configs')
        .select('job_id, status, questions_json')
        .in('job_id', jobIds)
        .eq('status', 'published');
      return readyInterviewJobIds(data);
    },
    enabled: jobIds.length > 0,
    staleTime: 30_000,
  });
}
